<div class="share-member-container">
  <sync-text-field inputType="chips" [label]="'Share with'"
    [errorMessage]="shareWithValidationErrorMessage"
    [chipConfig]="shareWithChipConfig" 
    [chipItems]="shareWithChipItems" 
    [chipValues]="onShareWithItemChange"
    [autoSuggestionConfig]="shareWithAutoSuggestionItems.length > 0 ? shareWithAutoSuggestionConfig : null"
    [autoSuggestionOptionItems]="shareWithAutoSuggestionItems"
    [triggerCallback]="shareWithTriggerCallback"
    [trailAdornments]="true"
    trailAdornmentsType="icon"
    [trailIconAdornment]="'arrow-triangle-down'">
  </sync-text-field>

  <div class="permission-box">
    <p class="caption">User permissions</p>
    <div class="permission-container">
      <div class="permission">
        <div>
          <sync-checkbox
            [label]="'Can view'"
            [checked]="true"
            [indeterminate]="false"
            [disabled]="true"
          ></sync-checkbox>
        </div>

        <div>
          <sync-checkbox
            [onChange]="onCheckCanEditChange"
            [label]="'Can edit'"
            [checked]="true"
            [indeterminate]="false"
            [disabled]="!isPro"
          ></sync-checkbox>
        </div>
      </div>

      <div class="permission">
        <div>
          <sync-checkbox
            [onChange]="onCheckCanInviteChange"
            [label]="'Can invite'"
            [checked]="false"
            [indeterminate]="false"
            [disabled]="false"
          ></sync-checkbox>
        </div>
        <div>
          <sync-checkbox
            [onChange]="onCheckCanSeeOthersChange"
            [label]="'See others'"
            [checked]="true"
            [indeterminate]="false"
            [disabled]="false"
          ></sync-checkbox>
        </div>
      </div>
    </div>
    <div class="caption message" *ngIf="isPro">
      All users will receive the same permissions. These settings can be changed
      later.
    </div>
    <div class="caption message" *ngIf="!isPro">All users will receive the same permissions. <a class="syncblue" (click)="openPortal()">Upgrade your account</a> to set read only permissions.</div>
  </div>

  <div class="text-area" *ngIf="isPro && !isOnTrial">
    <sync-text-field
      [inputType]="'text'"
      [label]="'Message (optional)'"
      [inputChange]="onChangeMessage"
      [dynamicMaxlength]="privateMessageErrorLength"
      [charCounter]="true"
      [errorMessage]="privateMessageError"
      [maxValue]="privateMessageErrorLength"
      
    ></sync-text-field>
  </div>
</div>
<ng-template #eventItemRef let-data="data">
{{data}} emai;
</ng-template>

<ng-template #shareWithItemRef let-data="data">
  <div class="share-with-item">
    <ng-container *ngIf="data.type === 'contact'">
      <span class="icon">
        <sync-avatar
          [size]="24"
          [initials]="data.email"
          [randomColor]="true"
          [isHoverable]="false">
        </sync-avatar>
      </span>
      <span class="primary">{{data.email}}</span>
    </ng-container>
    <ng-container *ngIf="data.type === 'role'">
      <span class="icon">
        <sync-icon name="role"></sync-icon>
      </span>
      <span class="primary">{{data.role.name}} (Role)</span>
      <span class="secondary">{{data.role.users.length}} user{{data.role.users.length === 1 ? '' : 's'}}</span>
    </ng-container>
  </div>
</ng-template>